import AuthService from "../../service/AuthService";
import {publicPath} from "../../app.config"
import swal from 'sweetalert'
import router from "../../router";

//export const namespaced = true

export const state = {
    token:null,
    isDocumentsUpt: false,
    authLoading: false,
    deviceId: '',
    loginRequest: {},
    screen: 'recovery1',
    orgScreen: 'stepTwo',
    loginScreen: 'login',
    regScreen: 'reg',
    userInfo: {
        accountno: '',
        countrycode: '',
        token: '',
        companies: {
            data: [],
            responseCode: '',
            responseMessage: ''
        },
        customerid: '',
        customername: '',
        email: '',
        role: '',
        firstName: '',
        lastName: '',
        mobilenumber: '',
        responseCode: '',
        responseMessage: '',
        id: '',
        username: ''
    },
    users: {
        totalUsers: "0",
        totalPendingUsers: "0",
        totalActiveUsers: "0",
        totalAdminUsers: "0",
        data: []
    },
    response:{}

}


export const getters = {
    getTok: state => {
        // console.log("getter getTok")
        return state.token
    },
    getUser: state => {
        // console.log("getter getTok")
        return state.userInfo
    },
    activeCompany: state => {
        // console.log("getter getTok")
        return state.userInfo.companies.data.filter(it=>it.orgID === localStorage.orgID)[0]
    }
}


export const mutations = {
    updateResponse:(state, payload) =>{
        state.response = payload
    },

    updateOrgScreen:(state, payload) =>{
        state.orgScreen = payload
    },

    updateLoginRequest:(state, payload) =>{
        state.loginRequest = payload
    },

    updateCompanies:(state, payload) =>{
        state.userInfo.companies = payload
    },

    updateDeviceId: (state, payload) =>{
        state.deviceId = payload
    },

    updateUsers: (state, payload) =>{
        state.users = payload
    },

    updateAuthLoading: (state, payload) =>{
        state.authLoading = payload
    },

    updateScreen: (state, payload) =>{
        state.screen = payload
    },

    updateLoginScreen: (state, payload) =>{
        state.loginScreen = payload
    },

    updateUser: (state, payload) =>{
        state.userInfo = payload
    },

    updateRegScreen: (state, payload) =>{
        state.regScreen = payload
    },

    updateAuthToken: (state, payload) =>{
        console.log("mutation updateAuthToken ==>>", payload)
        state.token = payload
    },

    // eslint-disable-next-line no-unused-vars
    reset: (state, payload) =>{
        state.token = null;
        state.isDocumentsUpt = false;
        state.authLoading = false;
        state.screen = 'login';
        state.regScreen = 'reg';
        state.response ={};
    },
}


export const actions = {
    // eslint-disable-next-line no-unused-vars
    logon: ({ commit, dispatch }, payload)=>{
        commit("updateAuthLoading", true)
        commit("updateResponse", {})
        return AuthService.callLogonApi(payload)
        .then(response => {
            commit("updateAuthLoading", false);
            let responseData = response.data;
            commit("updateResponse", responseData);
            if (responseData.responseCode === "00") {
                localStorage.token = responseData.token;
                commit("updateAuthToken", responseData.token);
                commit("updateUser", responseData);
                swal('Success!',responseData.responseMessage,'success')
                    .then(res=>{
                        console.log(res)
                        window.location = publicPath+'preloader'
                    });
            }else if (responseData.responseCode === "01") {
                swal(
                    'Info',responseData.responseMessage,'info'
                ).then(res => {
                    console.log(res);
                    commit("updateLoginScreen", 'otp')
                });

            }else if (responseData.responseCode === '95'){
                swal(
                    'Error',responseData.responseMessage,'error'
                ).then(res => {
                    console.log(res);
                    router.push('/forgot-password');
                });
            }else {
                swal('Error!',responseData.responseMessage,'error').then();
            }
            
        })
        .catch((error) => {
            commit("updateAuthLoading", false);
            alert(error+" login");
            // throw error;
            // return Promise.reject(error)
        });
    },

    validate({ commit, state }) {
        //getting token from local storage
        let rtn = false
        let userToken = null;

        if (state.token != null)
            userToken = state.token
        else
            userToken = localStorage.token
        //start App Loading
        commit("updateAuthLoading", true);

        if (userToken == null) {
            //stop App Loading
            commit("updateAuthLoading", false);
            router.push('/');
            // return rtn
        } else {
            let payload = {
                token: ""
            };
            return AuthService.callVerifyTokenApi(payload)
                .then(response=>{
                    commit("updateAuthLoading", false);
                    let responseData = response.data;
                    if (responseData.responseCode === '00'){
                        commit("updateUser", responseData);
                        rtn = true
                        return rtn
                    }else{
                        return rtn
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .catch(error=>{
                    commit("updateAuthLoading", false);
                    router.push('/');
                    return rtn
                })
        }

    },

    initiateResetPassword: ({ commit }, payload)=>{
        commit("updateAuthLoading", true)
        commit("updateResponse", {})
        return AuthService.callInitiateResetPasswordApi(payload)
        .then(response => {
            let responseData = response.data;
            commit("updateResponse", responseData)
            if (responseData.responsecode === "00") {
                commit("updateAuthLoading", false)
                localStorage.clear()
                swal('Success!',responseData.responsemessage,'success')
                    // eslint-disable-next-line no-unused-vars
                    .then(res=>{commit("updateScreen",'recovery2')});
            }else{
                commit("updateAuthLoading", false)
                swal('Error!',responseData.responsemessage,'error')
                    // eslint-disable-next-line no-unused-vars
                    .then(res=>{commit("updateScreen",'recovery1')});
            }
            
        })
        .catch(error => {
            commit("updateScreen",'recovery1')
            commit("updateAuthLoading", false)
            alert(error);
            // throw error;
        });
    },

    completeResetPassword: ({ commit }, payload)=>{
        commit("updateAuthLoading", true)
        return AuthService.callCompleteResetPasswordApi(payload)
            .then(response => {
                let responseData = response.data;
                commit("updateAuthLoading", false)
                if (responseData.responsecode === "00") {
                    localStorage.clear();
                    swal('Success!',responseData.responsemessage,'success')
                        // eslint-disable-next-line no-unused-vars
                        .then(res=>{
                            commit("updateScreen",'recovery1')
                            router.push('/');
                        });
                }else{
                    swal('Error!',responseData.responsemessage,'error')
                        // eslint-disable-next-line no-unused-vars
                        .then(res=>{
                            commit("updateScreen",'recovery1')
                            // router.push('/');
                        });
                }

            })
            .catch(error => {
                commit("updateAuthLoading", false)
                alert(error);
                // throw error;
            });
    },

    verifyToken: ({ commit }, payload)=>{
        commit("updateAuthLoading", true)
        return AuthService.callVerifyTokenApi(payload)
        .then(response => {
            let responseData = response.data;
            commit("updateAuthLoading", false)
            if (responseData.responseCode === "00") {
                // console.log("callVerifyTokenApi responseData ==>>", responseData);
                localStorage.clear()
                swal('Info!',responseData.responseMessage,'info')
                    // eslint-disable-next-line no-unused-vars
                    .then(res=>{commit("updateScreen",'recovery3')});
            }else{
                swal('Error!',responseData.responseMessage,'error')
                    // eslint-disable-next-line no-unused-vars
                    .then();
            }
            
        })
        .catch(error => {
            commit("updateAuthLoading", false)
            alert(error);
        });
    },

    changePassword: ({ commit }, payload)=>{
        commit("updateAuthLoading", true)
        return AuthService.callChangePasswordApi(payload)
        .then(response => {
            let responseData = response.data;
            commit("updateAuthLoading", false)
            if (responseData.responseCode === "00") {
                swal('Success!',responseData.responseMessage,'success')
            }else{
                swal('Error!',responseData.responseMessage,'error')
            }

        })
        .catch(error => {
            commit("updateAuthLoading", false)
            alert(error);
        });
    },

    createCompany: ({ commit, state }, payload)=>{
        commit("updateAuthLoading", true)
        console.log(state.loginRequest)
        return AuthService.callCreateCompanyApi(payload)
        .then(response =>  {
            let responseData = response.data;
            commit("updateAuthLoading", false);
            if (responseData.responseCode === "00") {
                // eslint-disable-next-line no-unused-vars
                swal('Success!',responseData.responseMessage,'success').then(result=>{
                    localStorage.removeItem('token')
                    // eslint-disable-next-line no-unused-vars
                    // dispatch("logon", state.loginRequest, { root: false }).then(result=>{
                        //window.location = publicPath+'preloader'
                    // })
                    window.location = publicPath+'preloader'
                })
            }else{
                swal('Error!',responseData.responseMessage,'error')
            }

        })
        .catch(error => {
            commit("updateAuthLoading", false)
            alert(error);
        });
    },
    readCompany: ({ commit }, payload)=>{
        //if(state.calenders.length < 1)
            //commit("updateCalenderLoading", true)
        return AuthService.callReadCompanyApi(payload)
            .then(response => {
                commit("updateAuthLoading", false)
                if (response.data.responseCode === "00") {
                    commit("updateAuthLoading", false)
                    let responseData = response.data;
                    commit("updateCompanies", responseData.data)
                }

            })
            .catch(error => {
                commit("updateAuthLoading", false)
                alert(error)
                // throw error;
            });
    },

    initiateEnrollment: ({ commit }, payload)=>{
        delete payload.dialogs;
        commit("updateAuthLoading", true)
        commit("updateResponse", {})
        return AuthService.callInitiateEnrollmentApi(payload)
        .then(response => {
            commit("updateAuthLoading", false)
            let responseData = response.data;
            commit("updateResponse", responseData)
            if (responseData.responseCode === "00") {
                swal('Info!',responseData.responseMessage,'info').then(commit("updateRegScreen", 'otp'));
            }else{
                swal('Error!',responseData.responseMessage,'error')//.then(router.push('/').then);
            }
            
        })
        .catch((error) => {
            commit("updateAuthLoading", false)
            alert(error);
        });
    },

    completeEnrollment: ({ commit }, payload)=>{
        delete payload.dialogs;
        commit("updateAuthLoading", true)
        commit("updateResponse", {})
        return AuthService.callCompleteEnrollmentApi(payload)
        .then(response => {
            commit("updateAuthLoading", false)
            let responseData = response.data;
            commit("updateResponse", responseData)
            if (responseData.responseCode === "00") {
                swal('Success!',responseData.responseMessage,'success')
                    // eslint-disable-next-line no-unused-vars
                    .then(res=>{
                        commit("updateRegScreen", 'reg')
                        router.push('/')
                    });
            }else{
                swal('Error!',responseData.responseMessage,'error').then();
            }
            
        })
        .catch((error) => {
            commit("updateAuthLoading", false)
            alert(error);
            // throw error;
            // return Promise.reject(error)
        });
    },

    updateUsers: ({ commit, state }, payload)=>{
        if(state.users.data.length < 1)
            commit("updateAuthLoading", true)
        return AuthService.callGetUsersApi(payload)
            .then(response => {
                commit("updateAuthLoading", false)
                if (response.data.responseCode === "00") {
                    commit("updateAuthLoading", false)
                    let responseData = response.data;
                    commit("updateUsers", responseData)
                }

            })
            .catch(error => {
                commit("updateAuthLoading", false)
                alert(error)
                // throw error;
            });
    },

    updateUser: ({ commit }, payload)=>{
        commit("updateUser",payload)
    },

    reset: ({ commit }, payload)=>{
        commit("reset",payload)
    }

}
